import { Injectable } from '@angular/core';
import { Command } from '../command/command';
import { CommandHandler } from '../command/command-handler';
import { State } from '../state';
import { AppState } from '../state.module';

export class LoginCommand implements Command {
  readonly name = 'login';

  constructor(private _userId: string,
    private _idToken: string,
    private _email: string,
    private _acl: string[],
    private _userTypeId: string) {
  }

  get userId(): string {
    return this._userId;
  }

  get idToken(): string {
    return this._idToken;
  }

  get email(): string {
    return this._email;
  }

  get acl(): string[] {
    return this._acl;
  }

  get userTypeId(): string {
    return this._userTypeId;
  }
}

export class LogoutCommand implements Command {
  readonly name = 'logout';
}

export class MarkAuthAsInitializedCommand implements Command {
  readonly name = 'mark_auth_as_initialized';
}

@Injectable()
export class AuthCommandHandlerService implements CommandHandler {

  handle(state: State, command: Command): State {
    const appState = (state as AppState);

    switch (command.name) {
      case 'login':
        const loginCommand = (command as LoginCommand);
        const appStateResult = appState.auth.login(
          loginCommand.userId,
          loginCommand.idToken,
          loginCommand.email,
          loginCommand.acl,
          loginCommand.userTypeId,
        );
        console.log("APP", appStateResult);
        return appStateResult;

      case 'logout':
        return appState.auth.logout();

      case 'mark_auth_as_initialized':
        return appState.auth.initialize();
    }

    throw new Error(`AuthCommandHandlerService cannot handle command "${command.name}".`);
  }
}



// WEBPACK FOOTER //
// ./src/app/state/auth/auth-command-handler.service.ts